import httpClient from "../config/httpClient";
import { mapShoppingCartConfigurationBundlesToUpdate } from "../adapters/configuration.adapter";
import { ShoppingCartConfigurationBundleDto, ShoppingCartConfigurationDto } from "../models/shoppingCart.model";
import { ShoppingCartAdapter, ShoppingCartBundlesPromotionsAndContractsDto } from "../shopping-cart";
import { ExtendedShoppingCartBundlePromotionsAndContracts, ExtendedShoppingCartBundlesPromotionsAndContracts } from "@/models/shopping-cart.model";

export abstract class ProductChangeOfAddress2ndPhaseService {
	private static readonly URL_BASE = "sys03/customers/products";
	private static readonly URL_CHANGE_OF_ADDRESS = "change-of-address-processes";
	private static readonly URL_SHOPPING_CARTS = "shopping-carts";
	private static readonly URL_SUMMARY = "summary";
	private static readonly URL_PROMOTIONS_AND_CONTACTS = "promotions-and-contracts";
	private static readonly URL_PROMOTIONS = "promotions";
	private static readonly URL_CONTRACTS = "contracts";
	private static readonly URL_CONFIGURATION = "configuration";
	private static readonly URL_SEND = "send";

	public static getById(processId: string) {
		const url = `${this.URL_BASE}/${this.URL_CHANGE_OF_ADDRESS}/${processId}`;
		return httpClient.get(url);
	}

	public static patch(productId: number, payload: any) {
		const url = `${this.URL_BASE}/${this.URL_CHANGE_OF_ADDRESS}/${productId}`;
		return httpClient.patch(url, payload);
	}

	public static getSummary({ shoppingCartId }: { shoppingCartId: string }) {
		const url = `${this.URL_BASE}/${this.URL_CHANGE_OF_ADDRESS}/${this.URL_SHOPPING_CARTS}/${shoppingCartId}/${this.URL_SUMMARY}`;
		return httpClient.get(url);
	}

	public static getPromotionsAndContracts({
		productId,
		shoppingCartId
	}: {
		productId: string;
		shoppingCartId: string;
	}): Promise<ExtendedShoppingCartBundlesPromotionsAndContracts> {
		const url = `${this.URL_BASE}/${productId}/${this.URL_CHANGE_OF_ADDRESS}/${this.URL_SHOPPING_CARTS}/${shoppingCartId}/${this.URL_PROMOTIONS_AND_CONTACTS}`;
		return httpClient.get<ShoppingCartBundlesPromotionsAndContractsDto>(url).then((response) => {
			const { data } = response;

			return ShoppingCartAdapter.extendShoppingCartBundlesPromotionsAndContractsDto(data);
		});
	}

	public static async putPromotions({
		productId,
		shoppingCartId,
		bundles = []
	}: {
		productId: string;
		shoppingCartId: string;
		bundles: ExtendedShoppingCartBundlePromotionsAndContracts[];
	}): Promise<ExtendedShoppingCartBundlesPromotionsAndContracts> {
		const url = `${this.URL_BASE}/${productId}/${this.URL_CHANGE_OF_ADDRESS}/${this.URL_SHOPPING_CARTS}/${shoppingCartId}/${this.URL_PROMOTIONS}`;

		const body = ShoppingCartAdapter.buildUpdateShoppingCartPromotionsDto({ bundles, applyDefaultContract: false });

		return httpClient.put<ShoppingCartBundlesPromotionsAndContractsDto>(url, body).then((response) => {
			const { data } = response;

			return ShoppingCartAdapter.extendShoppingCartBundlesPromotionsAndContractsDto(data);
		});
	}

	public static async putContracts({
		productId,
		shoppingCartId,
		bundles = []
	}: {
		productId: string;
		shoppingCartId: string;
		bundles: ExtendedShoppingCartBundlePromotionsAndContracts[];
	}): Promise<ExtendedShoppingCartBundlesPromotionsAndContracts> {
		const url = `${this.URL_BASE}/${productId}/${this.URL_CHANGE_OF_ADDRESS}/${this.URL_SHOPPING_CARTS}/${shoppingCartId}/${this.URL_CONTRACTS}`;

		const body = ShoppingCartAdapter.buildUpdateShoppingCartContractsDto({ bundles });

		return httpClient.put<ShoppingCartBundlesPromotionsAndContractsDto>(url, body).then((response) => {
			const { data } = response;

			return ShoppingCartAdapter.extendShoppingCartBundlesPromotionsAndContractsDto(data);
		});
	}

	public static getChangeOfAddress2ndPhaseConfiguration({ shoppingCartId }: { shoppingCartId: string }) {
		const url = `${this.URL_BASE}/${this.URL_CHANGE_OF_ADDRESS}/${this.URL_SHOPPING_CARTS}/${shoppingCartId}/${this.URL_CONFIGURATION}`;
		return httpClient.get<ShoppingCartConfigurationDto>(url);
	}

	public static putChangeOfAddress2ndPhaseConfiguration({ id, bundles = [] }: { id: string; bundles: ShoppingCartConfigurationBundleDto[] }) {
		const url = `${this.URL_BASE}/${this.URL_CHANGE_OF_ADDRESS}/${this.URL_SHOPPING_CARTS}/${id}/${this.URL_CONFIGURATION}`;
		const body = mapShoppingCartConfigurationBundlesToUpdate(bundles);

		return httpClient.put(url, body);
	}

	public static send(processId: string) {
		const url = `${this.URL_BASE}/${this.URL_CHANGE_OF_ADDRESS}/${processId}/${this.URL_SEND}`;
		return httpClient.put(url);
	}
}
